import clsx from "clsx";
import { FunctionComponent } from "react";

import * as styles from "@ui/components/article/ShareButtons/components/ShareButtonsSharePopover/ShareButtonsSharePopover.css";
import * as shareButtonsStyles from "@ui/components/article/ShareButtons/ShareButtons.css";
import LinkedinIcon from "@ui/components/icon/social/LinkedinIcon";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";

interface Props {
  url: string;
  onPopoverClose: () => void;
}

/**
 * LinkedIn share button component for the share popover
 */
const ShareButtonsLinkedinPopover: FunctionComponent<Props> = ({
  url,
  onPopoverClose,
}) => {
  const analytics = useAnalytics();

  const handleLinkedinShare = () => {
    analytics?.emit({
      event: "social_share",
      social_share: { platform: "linkedin" },
    });

    const encodedUrl = encodeURIComponent(url);
    const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
    window.open(
      linkedinUrl,
      "share_linkedin",
      "width=658, height=354, scrollbars=no",
    );
    onPopoverClose();
  };

  return (
    <button
      onClick={handleLinkedinShare}
      className={styles.shareOption}
      aria-label="Share on LinkedIn"
    >
      <span
        className={clsx(
          shareButtonsStyles.button.standard,
          styles.shareIconContainer,
        )}
      >
        <LinkedinIcon className={styles.shareIcon} />
      </span>
      <span className={styles.shareLabel}>LinkedIn</span>
    </button>
  );
};

export default ShareButtonsLinkedinPopover;
